<template>
		<div class="body">
			<router-view></router-view>
		</div>
</template>
  
<script lang="ts">
	import { Options, Vue } from 'vue-class-component';
  
	@Options({
	})
	export default class App extends Vue {}
</script>